import React, { useState } from 'react';

const ReportsPage = () => {
  const [activeReport, setActiveReport] = useState('project-progress');

  // Example report data
  const projectProgressData = [
    { project: 'Building A', progress: '60%', phase: 'Foundation', dueDate: '2025-03-01' },
    { project: 'Building B', progress: '45%', phase: 'Framing', dueDate: '2025-05-01' },
  ];

  const financialReportData = [
    { expenseType: 'Materials', budget: 50000, spent: 35000 },
    { expenseType: 'Labor', budget: 30000, spent: 20000 },
    { expenseType: 'Equipment', budget: 15000, spent: 12000 },
  ];

  const handleReportChange = (report) => {
    setActiveReport(report);
  };

  return (
    <div className="relative flex-1 p-10 overflow-y-auto ml-7 mr-2 min-h-screen">
      <div className="mx-auto bg-white p-6 shadow-lg rounded-xl" style={{ width: '80%' }}>
        <h1 className="text-2xl font-semibold mb-4">Construction Company Reports</h1>

        {/* Report Navigation */}
        <div className="flex space-x-4 mb-6">
          <button
            onClick={() => handleReportChange('project-progress')}
            className={`p-2 rounded-md ${activeReport === 'project-progress' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          >
            Project Progress
          </button>
          <button
            onClick={() => handleReportChange('financial')}
            className={`p-2 rounded-md ${activeReport === 'financial' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          >
            Financial Report
          </button>
          {/* Add more report buttons here */}
        </div>

        {/* Render Active Report */}
        {activeReport === 'project-progress' && (
          <div>
            <h2 className="text-xl font-semibold mb-4">Project Progress Report</h2>
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr>
                  <th className="border px-4 py-2">Project</th>
                  <th className="border px-4 py-2">Progress</th>
                  <th className="border px-4 py-2">Phase</th>
                  <th className="border px-4 py-2">Due Date</th>
                </tr>
              </thead>
              <tbody>
                {projectProgressData.map((data, index) => (
                  <tr key={index} className="border-b">
                    <td className="border px-4 py-2">{data.project}</td>
                    <td className="border px-4 py-2">{data.progress}</td>
                    <td className="border px-4 py-2">{data.phase}</td>
                    <td className="border px-4 py-2">{data.dueDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeReport === 'financial' && (
          <div>
            <h2 className="text-xl font-semibold mb-4">Financial Report</h2>
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr>
                  <th className="border px-4 py-2">Expense Type</th>
                  <th className="border px-4 py-2">Budget</th>
                  <th className="border px-4 py-2">Spent</th>
                </tr>
              </thead>
              <tbody>
                {financialReportData.map((data, index) => (
                  <tr key={index} className="border-b">
                    <td className="border px-4 py-2">{data.expenseType}</td>
                    <td className="border px-4 py-2">{data.budget}</td>
                    <td className="border px-4 py-2">{data.spent}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Add more reports conditionally based on activeReport */}
      </div>
    </div>
  );
};

export default ReportsPage;
